import { render, staticRenderFns } from "./PictureCardComp.vue?vue&type=template&id=23661992&scoped=true"
import script from "./PictureCardComp.vue?vue&type=script&lang=js"
export * from "./PictureCardComp.vue?vue&type=script&lang=js"
import style0 from "./PictureCardComp.vue?vue&type=style&index=0&id=23661992&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23661992",
  null
  
)

export default component.exports